/* eslint-disable no-undef */
import React, { Fragment, useContext, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { setPrimaryVersion } from 'actions/objectActions';
import { createImage, editImage, deleteDigitalContent } from 'actions/digitalContentActions';

import Form from 'react-bootstrap/Form';
import CreateResourceButton from 'field/edit/resource/CreateResourceButton';
import EditResourceDisplay from 'field/edit/resource/EditResourceDisplay';
import Header from 'field/common/Header';
import LocaleContext from 'constants/localization';
import Loading from 'components/common/Loading'; 
import { defaultVideoJSOptions, isVideoType } from '../../../../helpers/mediaHelpers';
import VideoJS from '../../../common/VideoJS';

// SPEC-38
const ImageEdit = ({ field, createImage, editImage, 
  deleteDigitalContent, primaryVersion, setPrimaryVersion}) => {
  const LS = useContext(LocaleContext);
  const [mediaLoading, setMediaLoading] = useState(false)
  const onCreate = () => createImage(field.values.length === 0,setMediaLoading);

  const onRemove = (index, value) => {
    let reason = prompt(LS.prompt.removalReason, '')
    if (reason == '') {
      reason = null;
    }

    if (confirm(LS.prompt.removeImage)) {
      deleteDigitalContent(value.uri, field.predicate, index, reason);
      if (primaryVersion === value.uri) {
        setPrimaryVersion(null);
      }
    }
  };

  const onEdit = (index, value) => {
    const isPrimaryVersion = value.uri === primaryVersion;
    editImage(index, value, isPrimaryVersion);
  };

  return (
    <Form.Group className="field" >
      <Header field={field} />
      <CreateResourceButton onCreate={onCreate} label={field.label} />
      { mediaLoading && <Loading /> }
      <EditLinkedResources 
        onEdit={onEdit}
        onRemove={onRemove}
        values={field.values} 
        setPrimaryVersion={setPrimaryVersion}
        primaryVersion={primaryVersion} />
    </Form.Group>
  );
};




const getVideoJSOptions = (uri) => defaultVideoJSOptions(`displayContent.do?uri=${uri}`);

const getDisplay = (uri, type) => `displayContent.do?uri=${uri}&type=${type}`;


const EditLinkedResources = ({ onEdit, onRemove, values, 
  setPrimaryVersion, primaryVersion }) => {
  const LS = useContext(LocaleContext);

  return (
    <Fragment>
      {
        values.map((value, index) => (
          <div key={index} className={'edit-resource field shaded'}>
            <div style={{marginBottom: '0.5rem'}} >
              {
                isVideoType(value.uri) && <div className='mediaEditVideo' > <VideoJS options={getVideoJSOptions(value.uri)}/> </div>
              }
              {
                !isVideoType(value.uri) &&               
                <a href={getDisplay(value.uri, 'master')} style={{ marginRight: '1rem' }} >
                  <img src={getDisplay(value.uri, 'thumb')}  />
                </a>
              }

              <button className="action-link" 
                type="button" 
                index={index} 
                onClick={() => onEdit(index, value)}>
                {LS.actions.edit}
              </button>
              <button className="action-link" 
                type="button"
                index={index}
                onClick={() => onRemove(index, value)}>
                {LS.actions.remove}
              </button>
              <input type="checkbox" 
                onKeyDown={e => e.key === 'Enter' && setPrimaryVersion(value.uri)}
                onChange={() => setPrimaryVersion(value.uri)} 
                checked={value.uri === primaryVersion} />
              <span>{LS.primaryVersion}</span>
            </div>
            <EditResourceDisplay value={value} />
          </div>
        ))
      }
    </Fragment>
  );
};

ImageEdit.propTypes = {
  field: PropTypes.object.isRequired,
  createImage: PropTypes.func.isRequired,
  editImage: PropTypes.func.isRequired,
  deleteDigitalContent: PropTypes.func.isRequired,
  setPrimaryVersion: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    primaryVersion: state.object.primaryVersion
  };
};

export default connect(mapStateToProps, {createImage,
  editImage, deleteDigitalContent, setPrimaryVersion})(ImageEdit);